import * as types from '../constants/actionTypes';
import initialState from './initialState';
import { fromJS } from 'immutable';

function immutableXlsImportsReducer(state, action) {
  switch (action.type) {
    case types.OPEN_IMPORT_SOURCES_MODAL:
      return state
        .set('modalOpen', true)
        .set('importResults', {})
        .set('importErrors', []);
    case types.DISMISS_IMPORT_SOURCES_MODAL:
      return state
        .set('modalOpen', false)
        .set('importResults', {})
        .set('importErrors', []);
    case types.IMPORT_XLS_FILES:
      return state
        .set('importing', true)
        .set('importResults', {})
        .set('importErrors', []);
    case types.IMPORT_XLS_FILES_SUCCESS:
      return state
        .set('importing', false)
        .set('importResults', action.data)
        .set('importErrors', []);
    case types.IMPORT_XLS_FILES_FAILURE:
      return state
        .set('importing', false)
        .set('importResults', {})
        .set('importErrors', action.data);
    case types.DOWNLOAD_XLS_TEMPLATES:
      return state
        .set('templatesZip', null);
    case types.DOWNLOAD_XLS_TEMPLATES_SUCCESS:
      return state
        .set('templatesZip', action.data);
    case types.DOWNLOAD_XLS_TEMPLATES_FAILURE:
      return state
        .set('templatesZip', null);

    default:
      return state;
  }
}

export default function xlsImportsReducer(state = initialState.xlsImports, action) {
  return immutableXlsImportsReducer(fromJS(state), action).toJS();
}




// WEBPACK FOOTER //
// ./src/reducers/xlsImportsReducer.js